import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { VALIDATE_PRICE, ALPHABATES_NUMERIC, NUMERIC_CHARACTERS } from '../../../constants/constants'
import { subscriptionUpdate, saveSubscription} from '../../../actions/subscriptionActions'
import { useDispatch } from "react-redux";
import { Modal, Button } from 'react-bootstrap';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

const FormSubscriptionModal = (props) => {

	const validationSchema = yup.object().shape({
		name: yup.string().required('Name is required').max(50, 'Name should be less than 50').matches(ALPHABATES_NUMERIC, "Only alphabates and numbers are allowed for this field"),
		projects_limit: yup.string().required('Projects limit is required').matches(NUMERIC_CHARACTERS, 'Please only enter numeric characters').max(10, 'This should be less than 10'),
		members_limit: yup.string().required('Members limit is required').matches(NUMERIC_CHARACTERS, 'Please only enter numeric characters').max(10, 'This should be less than 10'),
		partners_limit: yup.string().required('Partners limit is required').matches(NUMERIC_CHARACTERS, 'Please only enter numeric characters').max(10, 'This should be less than 10'),
		discounted_price: yup.string().required('Discounted price is required').matches(VALIDATE_PRICE, 'Please only enter numeric characters'),
		disk_space: yup.string().required('Disk space is required').matches(NUMERIC_CHARACTERS, 'Only numbers are allowed for this field'),
		price: yup.string().required(' Price is required').min(2, 'Price should be greater than 2').max(10, 'Price should be less than 10').matches(VALIDATE_PRICE, "Only numbers are allowed for this field"),
	   
	});
	const dispatch = useDispatch();
	const { register, handleSubmit, reset, setValue, formState: { errors, ...formState } } = useForm({
		mode: "onBlur",
		resolver: yupResolver(validationSchema),
	}),
		[inputName, setInputName] = useState(""),
		[inputPrice, setInputPrice] = useState(""),
		[inputDiscountePrice, setInputDiscountePrice] = useState(""),
		[inputProjectsLimit, setInputProjectsLimit] = useState(""),
		[inputMembersLimit, setInputMembersLimit] = useState(""),
		[inputPartnersLimit, setInputPartnersLimit] = useState(""),
		[inputDiskSpace, setInputDiskSpace] = useState(""),
		[inputAdminTitle, setInputAdminTitle] = useState(""),
		[inputEdit, setInputEdit] = useState("");
	const { isValid } = formState

	const onAdminSubmit = async (values, e) => {
		if (props.data) {
			values.id = (props.data !== false) ? props.data.id : ''
		}
		//console.log("values", values);
		(props.data.mode && props.data.mode === "edit") ? dispatch(subscriptionUpdate(values)) : dispatch(saveSubscription(values));;
		props.close();
		//props.onLoad;
	};

	useEffect(() => {
		//console.log("my props", props);

		if (props.data && props.data.mode === "edit") {
			setValue('name', props.data.name)
			setValue('price', props.data.price)
			setValue('discounted_price', props.data.discounted_price)
			setValue('projects_limit', props.data.projects_limit)
			setValue('partners_limit', props.data.partners_limit)
			setValue('members_limit', props.data.members_limit)
			setValue('disk_space', props.data.disk_space)
			setInputName(props.data.name);
			setInputPrice(props.data.price);
			setInputDiscountePrice(props.data.discounted_price);
			setInputProjectsLimit(props.data.projects_limit);
			setInputMembersLimit(props.data.partners_limit);
			setInputPartnersLimit(props.data.members_limit);
			setInputDiskSpace(props.data.disk_space);
			setInputAdminTitle("Edit Sub Admin");
			setInputEdit("edit");
		} else {
			//console.log("within add");
			setValue('name', '')
			setValue('price', '')
			setValue('discounted_price', '')
			setValue('projects_limit', '')
			setValue('partners_limit', '')
			setValue('members_limit', '')
			setValue('disk_space', '')
			setInputName("");
			setInputPrice("");
			setInputDiscountePrice("");
			setInputProjectsLimit("");
			setInputMembersLimit("");
			setInputPartnersLimit("");
			setInputDiskSpace("");
			setInputEdit("add");
			setInputAdminTitle("Add new Sub Admin");
		}
	}, [props, reset, setValue]);

	return (
		props.open && (
			<Modal show={props.open} onHide={props.close}>
				<Modal.Header>
					<Modal.Title id="contained-modal-title">{inputAdminTitle}</Modal.Title>
					<Button variant="outline-danger" onClick={props.close}><i className="fa fa-close"></i></Button>
				</Modal.Header>
				<Modal.Body>
					<form className="needs-validation" onSubmit={handleSubmit(onAdminSubmit)}>
						<div className="modal-body">
						<div className="row">
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input1"> Name</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input1"
                                            name="name"
                                            placeholder="Please Enter Name"
                                            autoComplete="off"
                                            defaultValue={inputName}
									        onChange={(e) => setInputName(e.target.value)}
                                            {...register('name')}
                                            className="form-control" required />
                                        {errors.name && (
                                            <div className="text-danger">{errors.name.message}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input2">Projects Limit</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input2"
                                            placeholder="Please Enter Projects Limit"
                                            defaultValue={inputProjectsLimit}
									        onChange={(e) => setInputProjectsLimit(e.target.value)}
                                            {...register('projects_limit')}
                                            name="projects_limit"
                                            className="form-control" required />
                                        {errors.projects_limit && (
                                            <div className="text-danger">{errors.projects_limit.message}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input2">Members Limit</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input2"
                                            placeholder="Please Enter Members Limit"
                                            defaultValue={inputMembersLimit}
									        onChange={(e) => setInputMembersLimit(e.target.value)}
                                            {...register('members_limit')}
                                            name="members_limit"
                                            className="form-control" required />
                                        {errors.members_limit && (
                                            <div className="text-danger">{errors.members_limit.message}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input2">Partners Limit</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input2"
                                            placeholder="Please Enter Partners Limit"
                                            {...register('partners_limit')}
                                            name="partners_limit"
                                            defaultValue={inputPartnersLimit}
									        onChange={(e) => setInputPartnersLimit(e.target.value)}
                                            className="form-control" required />
                                        {errors.partners_limit && (
                                            <div className="text-danger">{errors.partners_limit.message}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input2">Price</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input2"
                                            placeholder="Please Enter Price"
                                            {...register('price')}
                                            defaultValue={inputPrice}
									        onChange={(e) => setInputPrice(e.target.value)}
                                            name="price"
                                            className="form-control" required />
                                        {errors.price && (
                                            <div className="text-danger">{errors.price.message}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div className="form-group">
                                        <label htmlFor="text-input2">Discounted Price</label><span className="text-danger">*</span>
                                        <input type="text" id="text-input2"
                                            placeholder="Please Enter Discounted Price"
                                            {...register('discounted_price')}
                                            defaultValue={inputDiscountePrice}
									        onChange={(e) => setInputDiscountePrice(e.target.value)}
                                            name="discounted_price"
                                            className="form-control" required />
                                        {errors.discounted_price && (
                                            <div className="text-danger">{errors.discounted_price.message}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12">
                                    <label htmlFor="text-input2">Disk Space</label><span className="text-danger">*</span>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control" onChange={(e) => setInputDiskSpace(e.target.value)} name="disk_space" defaultValue={inputDiskSpace} {...register('disk_space')} placeholder="Please Enter Disk Space" aria-label="Please Enter Disk Space" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon2">MB</span>
                                        </div>
                                    </div>
                                    {errors.disk_space && (
                                        <div className="text-danger">{errors.disk_space.message}</div>
                                    )}
                                </div>
                            </div>
                        </div>
						<div className="modal-footer">
							<button type="submit" className="btn button" disabled={(props.data.mode !== 'edit') && isValid}>Submit</button>
							<button type="button" className="btn btn-outline-white" data-dismiss="modal" onClick={props.close}>Cancel</button>
							{inputEdit === "edit" ? <button type="button" className="btn btn-outline-danger px-3 py-2 ml-auto" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) props.deleteData(e) }}>Delete</button> : ''}
						</div>
					</form>
				</Modal.Body>
			</Modal>
		)
	);
}

export default FormSubscriptionModal;
